import { Component, Input, OnInit } from '@angular/core';

import { IScheduleOverride, mapSpecialOpeningTimes } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'pickup-custom-opening-time',
  styles: [`
    .custom-opening-times {
      display: grid;
      grid-template-columns: auto 1fr;
      column-gap: 1.5rem;
      row-gap: .5rem;
    }
  `],
  template: `
    <ui-message-custom class="font-md">
      <div class="mb-1">
        {{ 'orderProcess.delivery.deliveryForms.openingTimes' | translate }}:
      </div>

      <div class="custom-opening-times">
        @for (item of openingTime; track $index) {
          <div>{{ item.dateRange }}</div>

          <div class="nowrap">
            @if (item.isClosed) {
              <span [translate]="'common.dayOff'">
                Closed
              </span>
            } @else {
              {{ item.time }}
            }
          </div>
        }
      </div>
    </ui-message-custom>
  `,
})
export class PickupCustomOpeningTimeComponent implements OnInit {
  @Input() specialOpeningTimes: IScheduleOverride[];

  openingTime: { dateRange: string, time: string | null, isClosed: boolean }[];

  ngOnInit() {
    this.openingTime = mapSpecialOpeningTimes(this.specialOpeningTimes);
  }
}
